// @flow

import styled from 'styled-components';
import spaceIcon from './assets/space-black.png';
import whiteSpaceIcon from './assets/space-white.png';
import backSpaceIcon from './assets/backspace-black.png';
import whiteBackSpaceIcon from './assets/backspace-white.png';

export default styled.div`
  padding: 7rem 0 0 0;
  width: 100%;
  > .searchBoxWrapper {
    width: 35rem;
    height: 5rem;
    background: rgba(255,255,255,.4);
    color: #020100;
    border-radius: 5rem;
    margin: 2.5rem auto 2rem;
    &.activeRow {
      border: .4rem solid #ea1d5d;
    }
    &.lg {
      margin: 5rem auto 4rem;
      width: 45rem;
    }
    > form {
      input {
        float: right;
        font-size: 2.5rem;
        margin: 0.4rem 2rem;
        height: 3.9rem;
        outline: none;
        border: none;
        width: calc(100% - 10rem);
        background: transparent;
        color: #fff;
        &::placeholder {
          color: #fff;
          opacity: 1;
        }
        &:-ms-input-placeholder {
          color: #fff;
        }
        &:-ms-input-placeholder {
          color: #fff;
        }
        &:focus::-webkit-input-placeholder {
          color: #fff;
        }
      }
    }
    > button {
      background: transparent;
      height: 5rem;
      width: 5rem;
      border: none;
      text-align: center;
      float: left;
      border-radius: 5rem;
      cursor: pointer;
      outline: none;
      padding: 0;
      margin: 0;
      &.activeItem {
        background: #fff;
        border: .35rem solid #ea1d5d;
        > i {
          color: #020100;
        }
      }
      > i {
        font-size: 2rem;
        color: #fff;
      }
      &:hover {
        background: #fff;
        > i {
          color: #020100;
        }
      }
    }
  }
  > .keyboardKeysRow {
    margin-bottom: 0;
    height: 3rem;
  }
  > ul {
    margin: 0;
    padding: 0;
    display: block;
    text-align: center;
    overflow: hidden;
    > li {
      list-style: none;
      display: inline-block;
      margin: 0;
      &.keybardAction {
        float: right;
      }
      > button {
        font-size: 1.9rem;
        width: 2.95rem;
        height: 2.95rem;
        text-align: center;
        cursor: pointer;
        color: #fff;
        background: transparent;
        border: none;
        outline: none;
        border-radius: 2rem;
        padding: 0;
        margin: 0;
        &:hover {
          background: rgba(255,255,255,.3);
        }
        &.activeItem {
          background: #fff;
          color: #020100;
          border: .2rem solid #ea1d5d;
        }
        &.keyboardButton {
          width: 3.5rem;
          height: 3.5rem;
          background-position: center center;
          background-repeat: no-repeat;
          margin-left: 1rem;
          background-size: 2.2rem 1.2rem;
        }
        &.spaceButton {
          background-image: url("${whiteSpaceIcon}");
          &.activeItem {
            background-image: url("${spaceIcon}");
          }
        }
        &.backSpaceButton {
          margin-right: 2rem;
          background-image: url("${whiteBackSpaceIcon}");
          &.activeItem {
            background-image: url("${backSpaceIcon}");
          }
        }
      }
    }
  }
  > .listsContainer {
    padding: 0 2rem 0 0;
    box-sizing: border-box;
    overflow: hidden;
    .listTitle {
      margin-top: 0;
    }
  }
`;
